import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useApi from "@/hooks/useApi";
import useToastAlert from "@/hooks/useToastAlert";
import AIIndexes from "./AIIndexes";
import AIChatbotSettingsTabs from "./AIChatbotSettingsTabs";
import AIChatbotTrainingSettingsTabs from "./AIChatbotTrainingSettingsTab";

interface WizardReturn {
  integrationLabel: string;
  returnPath: string;
  savedAt: number;
}

export default function AIChatbotTrainingIndex() {
  const api = useApi();
  const toastAlert = useToastAlert();
  const navigate = useNavigate();
  const [wizardReturn, setWizardReturn] = useState<WizardReturn | null>(null);

  useEffect(() => {
    try {
      const raw = localStorage.getItem("velaro_wizard_return");
      if (!raw) return;
      const data: WizardReturn = JSON.parse(raw);
      if (data.savedAt && Date.now() - data.savedAt < 2 * 60 * 60 * 1000) {
        setWizardReturn(data);
      } else {
        localStorage.removeItem("velaro_wizard_return");
      }
    } catch {}
  }, []);

  function handleBackToWizard() {
    localStorage.removeItem("velaro_wizard_return");
    navigate(wizardReturn?.returnPath || "/integrations");
  }

  return (
    <div>
      {wizardReturn && (
        <div className="mb-4 rounded-lg border border-indigo-200 bg-indigo-50 px-4 py-3 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 text-sm text-indigo-700">
            <i className="fa-solid fa-wand-magic-sparkles text-indigo-400" />
            <span>
              Setting up your <strong>{wizardReturn.integrationLabel}</strong> bot — configure your knowledge index below, then continue when ready.
            </span>
          </div>
          <button
            type="button"
            onClick={handleBackToWizard}
            className="flex-shrink-0 flex items-center gap-1.5 text-xs font-semibold text-indigo-700 hover:text-indigo-900 bg-indigo-100 hover:bg-indigo-200 px-3 py-1.5 rounded-lg transition-colors whitespace-nowrap"
          >
            <i className="fa-solid fa-arrow-left text-xs" />
            Continue setup
          </button>
        </div>
      )}
      <AIChatbotTrainingSettingsTabs selectedTab={"Index"} />
      <AIIndexes />
    </div>
  );
}
